module.exports = __webpack_public_path__ + "img/ProfilePic3.e03764a7.png";